export default "__VITE_ASSET__BXUDY0yU__"